import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby";

import { Link as ToolkitLink } from "@vinomofo/components";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface LinkProps extends GatsbyLinkProps<any> {
  isExternal?: boolean;
}

export const Link = (props: LinkProps): JSX.Element => {
  const { to, isExternal = false, children, ...rest } = props;

  const linkProps = { ...rest };

  if (isExternal || !to?.startsWith("/")) {
    linkProps["href"] = to;
  } else {
    linkProps["as"] = GatsbyLink;
    // split path and params so we can handle them separately
    const [path, params] = to.split("?");
    // ensure trailing slashes on internal paths
    const normalizedPath = `${path}/`.replace(/\/{2,}$/, "/");
    // join the normalized path back with any initial params
    linkProps["to"] = [normalizedPath, params].filter(Boolean).join("?");
  }

  return <ToolkitLink {...linkProps}>{children}</ToolkitLink>;
};
